<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import 'animate.css';
    import { computeCyberValid } from '@routes/validators/validator';
    const CONTEXT = getContext('CONTEXT');

    $: questions = $Policy.questions ? $Policy.questions : [];

    // APPLICANT QUESTIONS SECTION

    // Create a lookup map in one pass - much more efficient!
    $: questionMap = questions.reduce((map, question) => {
        map[question.question] = question;
        return map;
    }, {});

    // Now you can access any question efficiently
    $: ({
        'Do you Require Cyber Insurance?': cyber_liability_question,
        'Have you experienced a cyber event in the past three years that has resulted in a direct financial loss of more than CAD10,000?': cyber_event_question,
        'Have you had any legal action brought or threatened against you in the last five years as a direct result of a cyber event?': cyber_legal_action_question,
        'Have you had any regulatory action initiated against you in the last five years as a direct result of a cyber event?': cyber_regulatory_action_question,
        'Have you been involved in the direct supply of goods or services to the cannabis industry, nor are you involved directly with the use or supply of cryptocurrency?': cannabis_and_cryptocurrency_question,
        'Cyber Privacy Liability': cyber_privacy_liability_question,
        'Cyber Crime': cyber_crime_question,
    } = questionMap);

    // Create named values lookup map - ONE iteration instead of 9!
    $: namedValuesMap = ($Policy.saved_named_values || []).reduce((map, nv) => {
        map[nv.name] = nv.value?.trim() || '';
        return map;
    }, {});


    // Now efficiently check all values
    $: continue_cyber = namedValuesMap.cyber_required == 'yes';

    $: cyber_liability_valid = computeCyberValid($Policy);

    // Update CONTEXT when validation changes
    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            cyber: cyber_liability_valid
        }));
    }

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }


</script>

<div class="page-container">
    <div class="questions-wrapper">
        <!-- APPLICANT QUESTIONS -->
        {#if cyber_liability_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={cyber_liability_question} title='Do you Require Additional Cyber Insurance?' policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if continue_cyber}
            {#if cyber_event_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cyber_event_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
            {#if cyber_legal_action_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cyber_legal_action_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
            {#if cyber_regulatory_action_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cyber_regulatory_action_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
            {#if cannabis_and_cryptocurrency_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cannabis_and_cryptocurrency_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
            {#if cyber_privacy_liability_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cyber_privacy_liability_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
            {#if cyber_crime_question}
                <div class="animate__animated animate__fadeInUp">
                    <Question question={cyber_crime_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                </div>
            {/if}
        {/if}
    </div>
</div>
                            


<style>
    .page-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .questions-wrapper {
        width: 100%;
        max-width: 500px;
        margin-bottom: 2rem;
    }

    /* Section Container Styles */
    .section-container {
        width: 100%;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 2px solid #e9ecef;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 2rem 1.5rem;
        margin: 2rem 0;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    }

    .section-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding-bottom: 1.5rem;
        border-bottom: 2px solid #e9ecef;
    }

    .section-icon {
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
        border-radius: 16px;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.15);
    }

    .section-header h1 {
        font-size: 1.375rem;
        font-weight: 600;
        color: #1d1d1f;
        margin: 0;
        line-height: 1.3;
        letter-spacing: -0.01em;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .sub-questions {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .sub-question {
        position: relative;
    }

    @media (max-width: 768px) {
        .section-container {
            padding: 1.5rem 1rem;
            border-radius: 16px;
        }

        .section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }

        .section-header h1 {
            font-size: 1.25rem;
        }

        .section-icon {
            width: 48px;
            height: 48px;
            font-size: 1.75rem;
        }

        .sub-question {
            padding-left: 1rem;
        }

        .sub-question::before {
            width: 3px;
        }
    }
</style>